<template>
  <ul
    class="header-subcategories"
    :class="{
      'header-subcategories--visible': visible,
      'header-subcategories--col-2': list.length > 4,
    }"
    @mouseenter="$store.state._overlays.categoriesOverlay = true"
    @mouseleave="$store.state._overlays.categoriesOverlay = false"
    :style="computedStyle"
  >
    <li v-for="item in list" :key="item.id" class="header-subcategories__item">
      <router-link class="header-subcategories__link" :to="{ name: 'catalog', params: { id: item.id } }">
        {{ item.title }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "HeaderSubcategoriesComponent",
  props: {
    data: Object,
    active: Boolean,
    position: Object,
  },
  computed: {
    visible() {
      // показываю выпадающий список, если есть затемнение, это элемент на который навели и если есть подкатегории
      return this.$store.state._overlays.categoriesOverlay && this.active && this.data?.childs?.length;
    },
    list() {
      if (this.data?.childs) {
        return this.data.childs;
      }
      return [];
    },
    computedStyle() {
      if (!this.position) return {};

      const style = {};

      // Use the isRightSide property to determine positioning
      if (this.position.isRightSide) {
        // Element is closer to right side, position dropdown from the right edge
        if (this.position.right !== null && this.position.right !== undefined) {
          style.right = this.position.right + "px";
          style.left = "auto";
        }
      } else {
        // Element is closer to left side, position dropdown from the left edge
        if (this.position.left !== null && this.position.left !== undefined) {
          style.left = this.position.left + "px";
          style.right = "auto";
        }
      }

      return style;
    },
  },
};
</script>

<style lang="stylus">
.header-subcategories {
	pointer-events: none
	position: absolute;
	top: 100%
	padding: 15px 40px;
	padding-right: 0;
	border: 1px solid #eeeeee;
	background-color: var(--white);
	opacity: 0;
	visibility: hidden;
	overflow: hidden;
	z-index: -1;
	display: block;
	transition: opacity 0.2s ease-out, visibility 0.2s 0s linear, z-index 0s 0.2s linear;

	&--col-2 {
		column-count: 2;
	}

	&:hover,
	&--visible {
		pointer-events: auto
		z-index: 999;
		opacity: 1;
		visibility: visible;
		transition: opacity 0.2s ease-in, visibility 0.2s 0.1s linear;
	}

	&__item {
		page-break-inside: avoid;
		display: flex;
		align-items: center;
		width: 180px;
		margin-top: -35px;
		margin-right: 40px;
		opacity: 0;
		overflow: hidden;
		transition: opacity 0s 0s ease-out, margin 0.2s 0s ease-out;

		^[0]:hover &,
		^[0]--visible & {
			margin-top: 0;
			opacity: 1;
			transition: opacity 0.2s 0.15s ease-in, margin 0.2s 0.1s ease-out;
		}
	}

	&__link {
		position: relative;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-align: center;
		align-items: center;
		height: 100%;
		width: 100%;
		max-height: 200px;
		padding: 15px 0;
		padding-right: 15px;
		line-height: 1;
		transition: padding .2s ease;

		&:hover {
			padding-left: 15px;
			padding-right 0

			&::before {
				transform: scale(1);
				transition: 0.2s 0.1s ease;
			}
		}

		&::before {
			content: '';
			position: absolute;
			top: 1px;
			bottom: 0;
			left: 0;
			height: 6px;
			width: 6px;
			margin: auto;
			border-radius: 50%;
			background-color: var(--red);
			transform: scale(0);
		}
	}
}
</style>
